import { PaginationTypes, withPagination } from '~/components/Pagination';
import MultiApplicationsTable from './MultiApplicationsTable';
import { getEnvironmentMultiApplicationListQueryKey } from '~/api/tanstackUtils';
import { ApiConfigResponse, retryAuthorizedRequests } from '~/api';
import { MULTI_APPLICATION_LIST_PAGE_SIZE } from './utils';
import { getApplicationList } from '~/api/resources/multiApplications';

const MultiApplicationsTableComponent = withPagination(
  () => <MultiApplicationsTable />,
  {
    pageSize: MULTI_APPLICATION_LIST_PAGE_SIZE,
    paginationType: PaginationTypes.PAGE_NAVIGATION,

    fetcher: (pageDetails) => ({
      queryKey: getEnvironmentMultiApplicationListQueryKey(),
      queryFn: async () => {
        const response = await getApplicationList({
          includeAllClientsFilter: true,
          pageSize: MULTI_APPLICATION_LIST_PAGE_SIZE,
          pageToken: pageDetails().pageToken
        });
        return response;
      },
      retry: retryAuthorizedRequests
    }),
    dataParser: (data: ApiConfigResponse) => data.clients
  }
);

// const han

export default function MultiApplicationList() {
  return (
    <div>
      <MultiApplicationsTableComponent />
    </div>
  );
}
